module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Blurb"
  }, [_vm._v("Ron Fones lives in Staffordshire, England and together with his family, has kept horses for over 40 years. He and his wife built their own stables for the horses on a paddock near to their home. Twenty-two years ago, the homeless cat arrived at the stables and Ron and his wife Pat wrote an account of what happened following the cat’s arrival. Several months ago, Ron came across the diaries and decided to try and publish the story.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Heading ParaOverride-1"
  }, [_vm._v("Copyright © Ron Fones 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("The right of "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ron Fones")]), _vm._v(" to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("A CIP catalogue record for this title is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("ISBN 9781035815722 (Paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("ISBN 9781035815739 (ePub e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_vm._v("www.austinmacauley.com")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("First Published 2024")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Austin Macauley Publishers Ltd"), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("1 Canada Square")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Canary Wharf")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("London")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("E14 5AA")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Dedi ParaOverride-2"
  }, [_vm._v("This is dedicated in memory of my wife Pat Fones who had a great love of animals and nature. ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I would like to thank my granddaughter Sarah who typed the story and helped me to submit it to the publisher and my daughter Louise who has helped me to bring it forwards to final publication.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("I had to move some furniture whilst decorating the bedrooms in July 2022, and came across an envelope containing these diaries. They are over 20 years old, and tell the story of how Pat and I briefly became the owner of a cat and six kittens. The diary comes in two parts (Pat’s version and my version), as well as some photos we took at the time.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt7.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("Myself and my wife Pat, purchased a small field near Church Eaton, Staffordshire to keep our riding ponies, an assortment of sizes and ages, for two of our daughters and Pat to ride. Over the years, younger, bigger ponies had been purchased to replace the outgrown ones, and gradually we had been left with just two — Sacha, and a companion pony, Millie. On the field site, we had built a set of stables and a small storage shed to house our feed and hay. To care for the ponies, we visited the field twice daily, to feed them for the night in the winter months.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt9.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("Pat was a great animal lover and it had been one of her dreams to own a pony. All of our three daughters, Tracey, Dawn and Louise had learnt to ride. They had gradually grown up, with Dawn and Louise both continuing riding and having ponies over the years, but now our girls all had their own homes and families, and it was just Pat and I living at home, caring for a much smaller group of animals.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt11.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Chapter-Heading ParaOverride-4"
  }, [_vm._v("Ron’s Diary")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Just before Christmas, we saw a small cat in the field moving toward the shed. When we arrived, it seemed wary of coming too close and we assumed it was wild. Outside of the shed we had dumped some slabs and a couple of fence panels, 5’ square, leaning over the slabs and against the shed, next to the door. The cat looked terribly thin and we started putting some food on a platter, occasionally leaving it on the slabs. The food disappeared and we hoped it was eaten by the cat, which I named Marmalade, because of its strange colouring — orange & white. The cat started to come more often so we left food every day, and eventually because of the wet and cold weather, it  began sleeping in the shed on top of the hay. We left the food for her inside the shed, hoping she would stay and keep the rats and mice away. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Txt"
  }, [_vm._v("By this time, my wife Pat called the cat Scrap and I called it Puss. The cat started leaving us presents; dead mice and voles, and eventually one dead rat on the stable yard. Followed by another dead rat inside the shed. After two or three weeks, she had cleared all the mice and rats out, and kept us free of pests ever since. The cat grew more and more friendly and would rub against our legs and purr. We stroked and fussed her and looked forward to seeing her twice every day. Our daughter Louise had donated her a cat basket for her to sleep in. One day, we noticed her running about the field with another cat, and a week or so later we noticed the smell of a tomcat around the stable yard. The tomcat would not come near us but would sit in the hedge watching, or sit on the slabs outside. We did not feed the Tom as we did not want to encourage his attention to our cat, who had now received its latest name — ‘Lucy’.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("Around this time with our regular feeding, Lucy had changed from skin & bones to a nice fluffy, well-fed cat. Unfortunately, as March came along, she seemed to be getting a bit fat and by April, her tummy was well rounded. We realised she was probably pregnant. Towards the end of April, we borrowed from our daughter Dawn a cat carrier, and popped Lucy inside. We took her to the local vet who confirmed that Lucy was about two weeks from giving birth. Borrowing books from Louise and Dawn, we began to read up on cat midwifery details. We constructed a huge 3’ square cat pen with wire netting for a roof and a netted front opening door. We put some hay on the floor and placed a big cardboard box inside, with a flap and some newspaper for bedding.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("The plan was that as soon as Lucy gave birth, assuming it was in our shed, we would move the cat and kittens into the pen, secure it, keep them all safe and feed them until we could find new homes for the kittens. At eight weeks, the pen would also prevent Lucy from becoming pregnant again and we would have her neutered.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Week-1 ParaOverride-2"
  }, [_vm._v("Week 1")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Friday 11/05, I received an emergency phone call whilst at work from Pat the midwife. On arriving at the field that morning, the cat came to be fed and was decidedly slim. Where were her kittens? A quiet meowing could be heard. After some searching, we found the source of the noise. There they were, on top of the hay, about five feet from the ground. Lucy had made a sunken nest 9” down among the hay bales for her kittens, but there was a gap at the rear of the nest. Pat, on my advice, went back down the field with Dawn and wedged a cardboard box through the hay to secure the kittens at the back. How many — 1, 2, 3, 4, 5, 6! Because the nest was high up, it was close to the Perspex roof. I suggested placing some flat cardboard between the rafters to provide shade and keep them cool.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("Saturday (next day), our grandchildren Matthew & Katie came to stay with us. When we went down to the field in the afternoon to show them the kittens, we were concerned as it was very hot and inside the shed, the temperature seemed to be around 30°C. We checked on the kittens, but only four were in the nest. We assumed two might have died because of the heat maybe. We looked around but could not see or hear them anywhere. Panic set in. How could we prevent the other kittens from becoming overheated? We took the children home and put an emergency plan into effect. We hitched up a trailer and went straight back down to the field. Our plan was to put Lucy and the surviving kittens into a cat basket, load up the two bales of hay which formed the nest, bring it home, move Pat’s car out of the garage and rebuild the cat’s nest as near as possible to its original one, and let them live in the garage.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('p', {
    staticClass: "Graphics _idGenParaOverride-1"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("Next problem, would she adapt to the cat litter donated by Louise? For the first twenty-four hours, there was no sign of Lucy doing anything in the litter. Next plan: put a bucket of earth in the garage corner, spread it out about two–three inches deep. Bingo — Lucy used the earth litter. The next day, I cleaned it out and spread some earth over the proper cat litter tray. Success! She started to use the litter tray. I cleaned up the earth and away goes Lucy using the litter tray.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("By now, Lucy is drinking milk and eating cat food in large quantities three times a day. The kittens all seem to be doing well. After one week, all still seems well. Matthew has actually held two of the kittens for a special treat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Week-1 ParaOverride-2"
  }, [_vm._v("Week 2")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Kittens are filling out well and beginning to crawl about. They’re still being fed by Lucy. At eleven days, they started opening their eyes, but three of the kittens seem to have trouble doing this and the vet advised us to bathe them twice daily. We took Lucy and all of the kittens to the vet on Saturday to check their eyes and get some advice on worming the kittens. The vet says their eyes are okay but to keep bathing them. We are shown how to measure the kittens’ worming fluid, which has to be given via a dropper into their mouths. Mission accomplished on Sunday, and the kittens’ eyes are improving. They are weighing in at around ten–eleven oz.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("A miracle had occurred. When we arrived at the field, the two missing kittens were back in the nest. We put Lucy and all six kittens into the cat-carrier, with a lot of meowing and protest, and loaded the hay bales containing the nest into the trailer. We took the whole kaboodle back to our house.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Once back at the house, we unloaded the hay bales from the trailer and transferred it all into the garage. We opened the cat-carrier door to let Lucy and the kittens out. Lucy jumped up into the nest, lay down, and started feeding.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt23.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('p', {
    staticClass: "Week-1 ParaOverride-2"
  }, [_vm._v("Week 3")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We rearranged the hay to give the kittens easy access to come out of the nest box. They have started stretching their legs and crawling over each other. Some of the kittens are stretching up the box and standing on their hind legs. As soon as we moved the hay from the front of their nest, out came the kittens — one, two, three, four, five, six — and from then on, they were everywhere. At first, they staggered around a bit, and could not get down from the hay without hanging down and gradually, sliding three or four inches to the floor. By the end of the week, they were walking about and trying to climb. Lucy is feeding well, eating three meals and drinking plenty of milk. All of the kittens seem to be filling out evenly. We have to be very careful when we are in the garage so as not to step on a kitten as they rapidly get around everywhere. Three of the kittens are still having one eye bathed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt25.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Week-1 ParaOverride-2"
  }, [_vm._v("Week 4")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("At last, the kittens with one eye closed are improving, sometimes the eye is open and sometimes it is closed. Throughout the week, one kitten recovers and is okay but the two orange and white kittens still seem to struggle. By the end of the week, their eyes all seem okay.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("This week the kittens have become really mobile, they are now climbing up sacks, sitting in baskets, climbing and playing in cardboard boxes. Throughout the days and nights, as soon as Lucy lies down in the hay, the kittens all snuggle up to their mom for a feed and then they snuggle up together to sleep. This week we saw the first kitten lapping milk out of the dish and by the middle of the week, the two orange and white kittens had started to feed off sardines or kitten food. By the weekend, five kittens were eating solids, and three were also using the litter tray for the first time.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ron Fones")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt27.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Chapter-Heading ParaOverride-4"
  }, [_vm._v("Pat’s Diary")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dec. 2000")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("In early December: I saw a thin little cat hanging around the stables. After a while, I decided to leave a bit of food out. Not sure what’s eating it, but it always disappears.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Mid December: Cold wet weather, I find a cat inside the shed. We’re feeding it properly now, it has become friendly and waits to be fed.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Christmas time: We think the cat is here to stay. My youngest daughter Louise sends her a warm basket for Christmas. She likes to snuggle in it as the weather is very cold.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("After Christmas: Snow, so the cat stays in the shed a lot. We’re feeding her properly still, and she’s very friendly.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Jan-Heading-12345 ParaOverride-1"
  }, [_vm._v("Jan – Feb. 2001")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Much the same with the cat. No rats or mice this year, except dead ones left by the wheelbarrow! The cat is earning its keep.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("March 2001")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A Tomcat is hanging round. Our cat must be female. I don’t think too much about the results.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("April 2001.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("My birthday 6th April. The cat has gone fat; we think she is pregnant! Oh no!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("That night we took our cat, (now called Lucy) to the vet, and her pregnancy is confirmed. The vet suggests we have the kittens put to sleep and spay Lucy. But we don’t want to lose the kittens.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('p', {
    staticClass: "Jan-Heading-12345 ParaOverride-1"
  }, [_vm._v("May 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Louise’s birthday, 4th May.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The cat keeps coming each morning and is still fat (when will it happen?)")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Friday May 11th. I go to the field at 8 am as usual. Lucy comes for her breakfast, but today she is thin. Where are the kittens? I couldn’t find them, and decided to go home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("After tea, me and my husband Ron go down to the field again to look for the kittens. We walk into the large store shed where we kept the bales of hay. We can hear a faint mewing noise… from somewhere high up? Ron climbed up six feet high on top of the bales of hay to try and find where the noise was coming from. Eventually, he found a nest, Lucy had gone and scraped a nest in the hay. Six little kittens had been born, and all of them were healthy. Satisfied that Lucy and her kittens were happy and well, off we went home.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt31.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Jan-Heading-12345 ParaOverride-1"
  }, [_vm._v("Saturday 12th May")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The next morning, we go down to the field with our grandchildren Matthew and Katie, to see the kittens. The weather is HOT. The shed roof is made from plastic sheets, which makes the cat’s nest underneath it even warmer. Two of the kittens have disappeared — we look everywhere but can’t find them. We fear the worst. The remaining four kittens look very sick from the heat.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We take the kids home and go back to check on the kittens in the evening. I’m very worried.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("To keep the remaining four kittens safe we tried to make a ‘cage’ — a wooden frame and some chicken wire fastened to it — to keep them inside. We put some hay inside to make a nest.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("6 pm. We return to the shed, preparing for the worst. Magic! All six kittens and their Mum are back in the nest! I try to put Lucy into the cage we have made, with kittens, but she doesn’t like it and takes the kittens back to the shed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('p', {
    staticClass: "Indent-txt"
  }, [_vm._v("On Friday afternoon, we visit the vet for advice. This time we see a different and more sympathetic vet, who suggests that we bring the kittens home, as it will be cooler. So we took a trailer down to the field, loaded the hay bales and original cat nest into the trailer, put Lucy and the kittens into a cat-carrier that we’d borrowed from Louise, and brought the whole kaboodle back home. ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We unloaded everything out of the trailer and into the garage of our family home. We rebuilt the cat nest and let Lucy and the kittens out of the cat-carrier, onto the garage floor. Lucy climbed onto the bales of hay and into the area where the nest was, and snuggled down for a few minutes. She then came down and carried each kitten into the nest. When all six kittens were in the nest she lay down and they started to feed from her.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt35.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "Jan-Heading-12345 ParaOverride-1"
  }, [_vm._v("Sun 13th May AM")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("All kittens are well. Lucy accepts her new situation and she is feeding very well, she’s a great mother. We put a pile of earth in the corner for her to toilet, plus a litter tray. She uses the dirt the next day.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mon. 14th & Tue. 15th May")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Everything is OK. Kittens are well. Lucy has started to use the proper litter tray.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wed. 16th I spent the day in the garage working. Lucy happy, kittens well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Thursday 17th. OK. Lucy is using the litter tray properly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Pat Fones")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('p', {
    staticClass: "Graphics"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "image/9781035815722_txt37.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('p', {
    staticClass: "Chapter-Heading ParaOverride-4"
  }, [_vm._v("New beginnings")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("After about 8 weeks we decided to advertise the kittens for adoption in the local paper. We kept one kitten, Cleo, as company for Lucy. We named the kittens, identifying them by their colours:")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cleo — Tabby & white.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Tiny — Orange & white, with two small patches.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smudge — Orange & white, with a black tail.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bex — Black tail, black spot, and black patch on its head.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dark — Mostly tortoiseshell, and a coloured tail.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lucy 2 — Ginger & black tail, with four orange spots on the back and one black spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("All were adopted and a copy of instructions given to each adoptee, advising them how to look after their kitten:")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Born Friday May 11th.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wormed at 2 weeks, 5 weeks, and 8 weeks. Will now need worming about every 3 months. Should be vaccinated soon, and spayed at 6–8 months to avoid pregnancy.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Are being fed 3 or 4 times daily at present. About 2 teaspoons of food per meal, but you will soon see for yourself what is required.")])]), _vm._v(" "), _c('p', {
    staticClass: "Indent-Italic"
  }, [_vm._v("Feed from shallow dish or a plate at first.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Will possibly drink a small amount of semi-skimmed milk twice a day. Fresh water should always be available.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Have been fed on “Go Cat” and “Arthurs”, both of which are soft and easy to eat, rather than chunks which are difficult for young kittens. If you give a different brand, do so gradually so as not to upset their stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The best flavours are the fish and chicken varieties. Avoid red meat types, and those in gravy as these are too rich and cause diarrhoea.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Have also been having tuna or sardines in oil once a day, is useful to mix with tinned food.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Also like finely chopped chicken, and will eat small amount of “Go Cat Kitten” dried food.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Have used litter tray very well here, but may be a bit confused when moving to new home. Try sitting on tray after meals.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We hope everything goes well and you will get as much pleasure as we have done from your kitten.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The End")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dbd1a8d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781035815739_Epub.vue
// module id = 57
// module chunks = 0